import { Box, Flex } from "@chakra-ui/react"
import { FC } from "react"

import { PageHeader } from "common/components/PageHeader/PageHeader"
import { Search } from "features/inventory/search/Search"

const SupplierCreditView: FC = () => (
  <Box p={4}>
    <PageHeader buttonTitle="Add New Credit" title="Supplier Credit" onClick={() => {}} />
    <Flex data-testid="supplierCredit" direction="column" p={4}>
      <Search placeholder="Search for credit" titleButton="Search supplier credit" onSearch={() => {}} />
    </Flex>
  </Box>
)

export { SupplierCreditView }
